export default [
  {
    id: 'fbc8d4ca-9a1d-4c89-a4a2-5e9f79efd9d3',
    path: 'data-services',
    name: 'data-services',
    meta: { title: '数据服务管理' },
    children: [
      {
        id: '69b06cfb-0af1-487e-be03-ea221fae8d87',
        path: 'api-release',
        name: 'api-release',
        component: () => {
          return import('../views/dataServices/apiRelease')
        },
        meta: {
          title: 'API发布',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
            publish: {
              id: 4,
              name: 'publish',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '22f90118-a307-4420-9806-cbc95953484c',
        path: 'api-release-create',
        name: 'api-release-create',
        component: () => {
          return import('../views/dataServices/apiReleaseCreate')
        },
        meta: {
          title: 'API发布详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-services/api-release',
        },
      },
      {
        id: 'b50e9440-bf36-4e45-b932-506e1daa8e63',
        path: 'api-examine-list',
        name: 'api-examine-list',
        component: () => {
          return import('../views/dataServices/apiExamineList')
        },
        meta: {
          title: 'API审核',
          keepAlive: false,
          operations: {
            read: {
              id: 0,
              name: 'read',
              desc: '查看',
              access: true,
            },
            delete: {
              id: 1,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '审核',
              access: true,
            },
            approved: {
              id: 3,
              name: 'approved',
              desc: '审核通过',
              access: true,
            },
            unapproved: {
              id: 4,
              name: 'unapproved',
              desc: '审核不通过',
              access: true,
            },
          },
        },
      },
      {
        id: '6817488e-f8a9-4951-b453-eacb17f84883',
        path: 'api-examine',
        name: 'api-examine',
        component: () => {
          return import('../views/dataServices/apiExamine')
        },
        meta: {
          title: 'API审核详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-services/api-examine-list',
        },
      },
      {
        id: '075b0611-4356-4eee-8048-a978b2399e2b',
        path: 'api-apply-list',
        name: 'api-apply-list',
        component: () => {
          return import('../views/dataServices/apiApplyList')
        },
        meta: {
          title: 'API申请',
          keepAlive: false,
          operations: {
            apply: {
              id: 0,
              name: 'apply',
              desc: '申请',
              access: true,
            },
            submit: {
              id: 1,
              name: 'submit',
              desc: '提交',
              access: true,
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
            delete: {
              id: 4,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            withdraw: {
              id: 5,
              name: 'withdraw',
              desc: '撤回',
              access: true,
            },
          },
        },
      },
      {
        id: 'ccd7e070-05f0-48b2-a32f-89bdb6a24b2f',
        path: 'api-apply',
        name: 'api-apply',
        component: () => {
          return import('../views/dataServices/apiApply')
        },
        meta: {
          title: 'API申请详情',
          tabnab: false,
          hidden: true,
          keepAlive: false,
          activeMenu: '/legacy-resource/data-services/api-apply-list',
        },
      },
      {
        id: 'e5950d14-23df-4fa5-992c-e8e309cbd938',
        path: 'api-application-list',
        name: 'api-application-list',
        component: () => {
          return import('../views/dataServices/apiApplicationList')
        },
        meta: {
          title: 'API应用',
          keepAlive: false,
          operations: {
            update: {
              id: 0,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '109e9218-c4d7-449f-92d1-d6ce3b24a67f',
        path: 'data-mapping',
        name: 'data-mapping',
        component: () => {
          return import('../views/dataServices/dataMapping')
        },
        meta: {
          title: '数据映射',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
            verify: {
              id: 4,
              name: 'verify',
              desc: '验证',
              access: true,
            },
          },
        },
      },
      {
        id: 'f4e11122-2001-4f3c-b974-b3697f293686',
        path: 'database-configuration',
        name: 'database-configuration',
        component: () => {
          return import('../views/dataServices/databaseConfiguration')
        },
        meta: {
          title: '数据库配置',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: 'b2e82bfc-d39e-4d76-8bf3-3847f2e7a2b6',
        path: 'call-logging',
        name: 'call-logging',
        component: () => {
          return import('../views/dataServices/callLogging')
        },
        meta: {
          title: '调用记录',
          keepAlive: false,
        },
      },
      {
        id: '1f8e619c-b36f-4e22-9469-61c27ddbb3ca',
        path: 'data-service-monitoring',
        name: 'data-service-monitoring',
        component: () => {
          return import('../views/dataServices/dataServiceMonitoring')
        },
        meta: {
          title: '数据服务监控',
          keepAlive: false,
        },
      },
      {
        id: 'c64ae079-36ba-44b1-996d-d95f8330d2db',
        path: 'subscription-application',
        name: 'subscription-application',
        component: () => {
          return import('../views/dataServices/subscriptionApplication')
        },
        meta: {
          title: '订阅申请',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            audit: {
              id: 1,
              name: 'audit',
              desc: '审核',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
          },
        },
      },
      {
        id: '229d9008-ce90-466c-a655-60e08f921ee5',
        path: 'subscribe-publish',
        name: 'subscribe-publish',
        component: () => {
          return import('../views/dataServices/subscribePublish')
        },
        meta: {
          title: '订阅发布',
          keepAlive: false,
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            update: {
              id: 1,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 2,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            read: {
              id: 3,
              name: 'read',
              desc: '查看',
              access: true,
            },
            enable: {
              id: 4,
              name: 'enable',
              desc: '启用',
              access: true,
            },
          },
        },
      },
    ],
  },
]
